import React from 'react';
import {
  Box,
  Button,
  Flex,
  Heading,
  Input,
  Spinner,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import DefaultAuth from 'layouts/auth/Default';
import illustration from 'assets/img/auth/auth.png';
import { AuthContext } from 'contexts/AuthContext';

export default function CompleteMagicLink() {
  const { completeMagicLinkSignIn } = React.useContext(AuthContext);
  const history = useHistory();
  const [email, setEmail] = React.useState('');
  const [needsEmail, setNeedsEmail] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState('');

  const textColor = useColorModeValue('navy.700', 'white');
  const textColorSecondary = 'gray.500';

  const completeSignIn = React.useCallback(async (emailOverride) => {
    setLoading(true);
    setError('');
    const result = await completeMagicLinkSignIn(window.location.href, emailOverride);
    if (result) {
      if (result.includes('email address')) {
        setNeedsEmail(true);
      }
      setError(result);
      setLoading(false);
      return;
    }

    history.replace('/admin/default');
  }, [completeMagicLinkSignIn, history]);

  React.useEffect(() => {
    completeSignIn();
  }, [completeSignIn]);

  return (
    <DefaultAuth illustrationBackground={illustration} image={illustration}>
      <Flex
        maxW={{ base: '100%', md: '420px' }}
        w="100%"
        mx={{ base: 'auto', lg: '0px' }}
        me="auto"
        h="100%"
        alignItems="start"
        justifyContent="center"
        px={{ base: '25px', md: '0px' }}
        mt={{ base: '40px', md: '18vh' }}
        flexDirection="column"
      >
        <Box>
          <Heading color={textColor} fontSize="34px" mb="12px">
            Completing Sign In
          </Heading>
          <Text color={textColorSecondary} mb="24px">
            We are verifying your secure sign-in link.
          </Text>
        </Box>

        {loading ? (
          <Flex align="center" gap="12px">
            <Spinner color="brand.500" />
            <Text color={textColorSecondary}>Signing you in...</Text>
          </Flex>
        ) : (
          <Flex direction="column" w="100%" gap="14px">
            {needsEmail && (
              <Input
                variant="auth"
                placeholder="Enter your email"
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
            )}
            {error && (
              <Text color="red.500" fontSize="sm" fontWeight="600">
                {error}
              </Text>
            )}
            {needsEmail ? (
              <Button variant="brand" onClick={() => completeSignIn(email)}>
                Complete Sign In
              </Button>
            ) : (
              <Button variant="brand" onClick={() => history.replace('/auth/sign-in')}>
                Back to Sign In
              </Button>
            )}
          </Flex>
        )}
      </Flex>
    </DefaultAuth>
  );
}
